export default "__VITE_ASSET__DXKVQhhv__"